export default "{\n    \"label\": \"Fabricante\",\n    \"placeholder\": \"Seleccione fabricante\"\n}"